<template>
  <div class="categorySelector">
    <v-container fluid>
      <p>Kies categorie*</p>
      <v-select
        v-model="selectedCategory"
        :items="categoryItems"
        item-text="title"
        outlined
        required
        v-on:change="selected"
      ></v-select>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { services } from "../_services";
import { mapActions } from "vuex";

export default {
  props: {
    formModel: Object,
  },
  data: function () {
    return {
        selectedCategory: { id: 0, title: "--Waar heeft u klachten of waar heeft u last van?--" },
        categoryItems: [{ id: 0, title: "--Waar heeft u klachten of waar heeft u last van?--" }],
    };
  },
  computed: {
    appointmentTypeChange() {
      return this.formModel.appointmentType;
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      showAlert: "alert/error",
      selectComp: "appBar/selectComp",
      updateFormModel: "appBar/updateFormModel",
    }),
    selected(option) {
      var category = this.categoryItems.find((x) => x.title == option);
      var title = category.title;
      var $this = this;

      if (category.id == 0) {
        this.updateFormModel({
            formModel: {
                id: 2,
                title: "",
                categoryId: parseInt(category.id, 10),
                categoryTitle: category.title,
                selected: false
            },
          callback: function () {
            $this.selectComp({
              id: 2,
              type: "select",
              resetData: true,
              emptySelection: true,
            });
          },
        });
        return;
      }

      this.updateFormModel({
        formModel: {
          id: 2,
          title: title,
          categoryId: parseInt(category.id, 10),
          categoryTitle: category.title,
          selected: true,
        },
        callback: function() {
            $this.selectComp({
              id: 3,
              type: "select",
              resetData: true,
              emptySelection: false,
            });
        }});
    },
  },
  watch: {
    appointmentTypeChange() {
      if (this.formModel.appointmentType != null) {
        services.fetchTypeKlacht(this.formModel).then(
          (data) => {
            this.categoryItems = this.categoryItems.concat(data);

            this.selectComp({
              id: 2,
              type: "select",
              resetData: false,
              emptySelection: false,
            });
          },
          (error) => {
            this.showAlert(error);
          }
        );
      }
    },
  },
};
</script>